<template>
  <div class="manufacturer-search-page">
    <div class="d-flex align-items-end justify-content-between">
      <h2>Manufacturer Search</h2>
      <div v-if="can('toggle-manufacturers')" class="m-0 p-0 row align-items-center">
        <div class="mr-1 font-weight-bolder text-primary" >Smart Catalog Manufacturers</div>
        <Toggle-Switch v-model="showSmartCatalogManufacturers"/> 
      </div>
    </div>
    <hr>
    <BasicDataGrid 
      :dataSource="dataSource"
      :dataGridKey="dataGridKey" 
      :columns="columns"
      :actions="actions"
      v-on:editManufacturer="routeToManufacturer($event)"
      :showColumnLines="true" />
  </div>
</template>
<script>
import BasicDataGrid       from '../../../components/BasicDataGrid.vue';

import { ManufacturerService } from '@/services';

import { can }             from '@/permissions.js'

// import { getDataSource }    from "../../../modules/helpers.js";
// let manufacturers = getDataSource('Manufacturers')

export default {
  name: 'ManufacturerSearch',
  components: {
    BasicDataGrid,
  },
  data() {
    return {
      dataGridKey: 'Id',
      manufacturers: [],
      smartCatalogManufacturers: [],
      showSmartCatalogManufacturers: false,
      DMcolumns: [
        { text: 'ID'   , value: 'Id'         , dataType: 'string' },
        { text: 'Code' , value: 'CompanyCode'},
        { text: 'Name' , value: 'CompanyName'},
        { text: 'Phone', value: 'Phone'},
        { text: 'Fax'  , value: 'Fax'},
        { text: 'Address',
          value: 'Address',
          customizeText: (cellInfo) => {
              return this.getCompleteAddress(cellInfo.value);
          }
        },        
      ],
      SCMcolumns: [
        { text: 'ID'   , value: 'Id'         , dataType: 'string' },
        { text: 'Code' , value: 'DCCode'},
        { text: 'Name' , value: 'CompanyName'},
        { text: 'Phone', value: 'Phone'},
        { text: 'Fax'  , value: 'Fax'},
        { text: 'Address',
          value: 'Address',
          customizeText: (cellInfo) => {
              return this.getCompleteAddress(cellInfo.value);
          }
        },        
      ],
    };
  },
  computed: {
     actions(){
       if (!can('edit-manufacturers')) return; // guard clause
       return [
         {
           hint: 'Edit',
           icon: 'edit',
           emit: 'editManufacturer',
         },
       ];
     },
     columns(){
       return this.showSmartCatalogManufacturers ? this.SCMcolumns : this.DMcolumns;
     },
     dataSource(){
       return this.showSmartCatalogManufacturers ? this.smartCatalogManufacturers : this.manufacturers;
     }
  },
  methods: {
    routeToManufacturer(e){
       let manufacturerId = e.row.data.Id;
       if (this.showSmartCatalogManufacturers){
         this.$router.push({ name: 'SmartCatalogManufacturerEdit', params: { id: manufacturerId } } );
       } else {
         this.$router.push({ name: 'ManufacturerEdit', params: { id: manufacturerId } } );
       }
       
    },
    getCompleteAddress(value){
      if(!value) return '';
      let completeAddress = [value.Line1, value.Line2, value.City, value.StateCode].join(', ');
      completeAddress = [completeAddress, value.ZipCode].join(' ').replace(", ,",",");;
      return completeAddress;
    },
    getManufacturers(){
      this.manufacturers = ManufacturerService.getDataSource(this.dataGridKey);
    },
    getSmartCatalogManufacturers(){
      this.smartCatalogManufacturers = ManufacturerService.getDataSourceSmartCatManufacturers(this.dataGridKey)
    }
  },
  created(){
    this.getManufacturers();
    this.getSmartCatalogManufacturers();
  }
};
</script>
<style lang="scss" scoped>
  .manufacturer-search-page{
    // max-width: 1800px;
  }
  .btn-wrapper{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    .btn {
      margin: 5px;
    }
  }
  .subheader-wrapper{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon-group{
      color: $primary;
      i{
        margin: 5px;
        cursor: pointer;
      }
    }
  }
</style>
